import './about.css'
import Aboutus from '../../pages/aboutus/Aboutus'
export default function About() {
  return (
    <div className='about'>
      <Aboutus/>
    </div>
  )
}
